import { NET } from './constants';
import type { InputMessage, Vec } from './types';

/** Snap analog movement to a small grid so identical intent produces identical bytes. */
export function quantizeMove(v: Vec): Vec {
  const q = (n: number) => Math.round(Math.max(-1, Math.min(1, n)) * 20) / 20;
  return { x: q(v.x), y: q(v.y) };
}

/** Snap aim to NET.aimSteps directions; mouse jitter then stops generating messages. */
export function quantizeAim(v: Vec): Vec {
  const a = Math.atan2(v.y, v.x);
  const step = (Math.PI * 2) / NET.aimSteps;
  const snapped = Math.round(a / step) * step;
  return { x: Math.cos(snapped), y: Math.sin(snapped) };
}

/** True when an input differs from the last one sent, or the keepalive interval has elapsed. */
export function inputChanged(next: InputMessage, lastSent: InputMessage | null): boolean {
  if (!lastSent) return true;
  if (next.teleport) return true;
  if (next.seq - lastSent.seq >= NET.inputKeepaliveTicks) return true;
  return next.move.x !== lastSent.move.x || next.move.y !== lastSent.move.y || next.aim.x !== lastSent.aim.x || next.aim.y !== lastSent.aim.y;
}
